import React from 'react';
import styles from './contentPage.module.scss';

function ContentPage({ children }) {
  return <div className={styles.contentPage}>{children}</div>;
}

export default ContentPage;
